// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Commission_upper__2lwWJ {
  display: grid;
  grid-template-columns: 3fr 1.5fr;
  gap: 2rem;
}
@media only screen and (max-width: 56.25em) {
  .Commission_upper__2lwWJ {
    grid-template-columns: 100%;
  }
}
.Commission_upper__ql__e7v7P {
  width: 100%;
  border-radius: 2rem;
  background-color: var(--color-white);
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  padding: 3.5rem 2rem;
  height: fit-content;
  align-self: center;
}
@media only screen and (max-width: 56.25em) {
  .Commission_upper__ql__e7v7P {
    width: 95%;
    justify-self: center;
  }
}
.Commission_upper__ql__content__jVV6P {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  box-sizing: border-box;
  gap: 2rem;
  margin-top: 3rem;
}
.Commission_upper__metrics__hx6QF {
  padding: 3.5rem 2rem;
  width: 100%;
  display: grid;
  box-sizing: border-box;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
}
@media only screen and (max-width: 37.5em) {
  .Commission_upper__metrics__hx6QF {
    grid-template-columns: repeat(2, 50%);
  }
}
.Commission_upper__metrics_paid__LLhRj {
  background-color: var(--color-green);
  color: var(--color-white);
}
.Commission_upper__metrics_unpaid__UvqwG {
  background-color: var(--color-error);
  color: var(--color-white);
}
.Commission_upper__metrics_partPaid__Wgehm {
  background-color: var(--color-yellow);
}
.Commission_upper__metrics_vat__-B\\+vh {
  background-color: var(--color-light-red);
}
.Commission_upper__metrics_discount__pdV6r {
  background-color: var(--color-primary-7);
}
.Commission_upper__metrics_due__UWmPT {
  background-color: var(--color-error);
  color: var(--color-white);
}
.Commission_upper__metrics_owe__7JFbq {
  background-color: var(--color-error);
  color: var(--color-white);
}

.Commission_main__wxD3E {
  display: grid;
  grid-template-columns: 1.85fr 1fr;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
}
@media only screen and (max-width: 37.5em) {
  .Commission_main__wxD3E {
    grid-template-columns: 100%;
  }
}
.Commission_main_nav__wXIYL {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 2rem;
  padding: 0 2rem;
  background-color: var(--color-white);
  border-bottom: solid 1px var(--color-dark);
  border-radius: 1rem 1rem 0 0;
}
.Commission_main_nav__wXIYL > :not(:last-child) {
  margin-right: 1rem;
}
.Commission_main_nav_group__CASzZ {
  position: relative;
}
.Commission_main_nav_more__HmOMG {
  position: absolute;
  right: 0;
  top: 75%;
  background-color: var(--color-white);
  padding: 1.5rem;
  border-radius: 1rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  z-index: 5;
}
.Commission_main_nav_more__HmOMG > :not(last-child) {
  margin-bottom: 1rem;
}
.Commission_main_nav_item__2fPtK {
  cursor: pointer;
  padding: 1rem 0;
  box-sizing: border-box;
  font-size: var(--default-font-small);
}
.Commission_main_nav_item_active__XJfwq {
  cursor: pointer;
  padding: 1rem 0;
  box-sizing: border-box;
  font-size: var(--default-font-small);
  font-weight: 700;
  color: var(--color-primary);
  border-bottom: solid 2px var(--color-primary);
}
.Commission_main_nav_item__2fPtK:hover, .Commission_main_nav_item__2fPtK:focus, .Commission_main_nav_item__2fPtK:focus-visible, .Commission_main_nav_item__2fPtK:focus-within {
  font-weight: 700;
  color: var(--color-primary);
  border-bottom: solid 2px var(--color-primary);
}

.Commission_success__BdwBn {
  height: 27rem;
  margin-bottom: 3rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Commission/Commission.module.scss"],"names":[],"mappings":"AAEA;EACC,aAAA;EACA,gCAAA;EACA,SAAA;AADD;AAGC;EALD;IAME,2BAAA;EAAA;AACF;AAQC;EACC,WAAA;EACA,mBAAA;EACA,oCAAA;EACA,4CAAA;EACA,sBAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;AANF;AAQE;EAVD;IAWE,UAAA;IACA,oBAAA;EALD;AACF;AAOE;EACC,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AALH;AASC;EAEC,oBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,qCAAA;EACA,SAAA;AAPF;AASE;EATD;IAUE,qCAAA;EAND;AACF;AAQE;EACC,oCAAA;EACA,yBAAA;AANH;AASE;EACC,oCAAA;EACA,yBAAA;AAPH;AAUE;EACC,qCAAA;AARH;AAWE;EACC,wCAAA;AATH;AAYE;EACC,wCAAA;AAVH;AAaE;EACC,oCAAA;EACA,yBAAA;AAXH;AAcE;EACC,oCAAA;EACA,yBAAA;AAZH;;AAiBA;EACC,aAAA;EACA,iCAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;AAdD;AAgBC;EAPD;IAQE,2BAAA;EAbA;AACF;AAeC;EACC,aAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EAEA,oCAAA;EACA,0CAAA;EACA,4BAAA;AAdF;AAgBE;EACC,kBAAA;AAdH;AAiBE;EACC,kBAAA;AAfH;AAkBE;EACC,kBAAA;EACA,QAAA;EACA,QAAA;EACA,oCAAA;EACA,eAAA;EACA,mBAAA;EACA,4CAAA;EACA,UAAA;AAhBH;AAkBG;EACC,mBAAA;AAhBJ;AAoBE;EACC,eAAA;EACA,eAAA;EACA,sBAAA;EACA,oCAAA;AAlBH;AAwBG;EACC,eAAA;EACA,eAAA;EACA,sBAAA;EACA,oCAAA;EACA,gBAAA;EACA,2BAAA;EACA,6CAAA;AAtBJ;AAyBG;EAIC,gBAAA;EACA,2BAAA;EACA,6CAAA;AA1BJ;;AAqCA;EACC,aAAA;EACA,mBAAA;AAlCD","sourcesContent":["@import '../variables/breakpoints';\n\n.upper {\n\tdisplay: grid;\n\tgrid-template-columns: 3fr 1.5fr;\n\tgap: 2rem;\n\n\t@media only screen and (max-width: $bp-900) {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t// &__search {\n\t// \tgrid-column: 1/3;\n\t// \tgrid-row: 1/2;\n\t// \tjustify-self: center;\n\t// }\n\n\t&__ql {\n\t\twidth: 100%;\n\t\tborder-radius: 2rem;\n\t\tbackground-color: var(--color-white);\n\t\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\t\tbox-sizing: border-box;\n\t\tpadding: 3.5rem 2rem;\n\t\theight: fit-content;\n\t\talign-self: center;\n\n\t\t@media only screen and (max-width: $bp-900) {\n\t\t\twidth: 95%;\n\t\t\tjustify-self: center;\n\t\t}\n\n\t\t&__content {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tjustify-content: space-evenly;\n\t\t\tbox-sizing: border-box;\n\t\t\tgap: 2rem;\n\t\t\tmargin-top: 3rem;\n\t\t}\n\t}\n\n\t&__metrics {\n\t\tbox-sizing: border-box;\n\t\tpadding: 3.5rem 2rem;\n\t\twidth: 100%;\n\t\tdisplay: grid;\n\t\tbox-sizing: border-box;\n\t\tgrid-template-columns: repeat(3, 1fr);\n\t\tgap: 2rem;\n\n\t\t@media only screen and (max-width: $bp-600) {\n\t\t\tgrid-template-columns: repeat(2, 50%);\n\t\t}\n\n\t\t&_paid {\n\t\t\tbackground-color: var(--color-green);\n\t\t\tcolor: var(--color-white);\n\t\t}\n\n\t\t&_unpaid {\n\t\t\tbackground-color: var(--color-error);\n\t\t\tcolor: var(--color-white);\n\t\t}\n\n\t\t&_partPaid {\n\t\t\tbackground-color: var(--color-yellow);\n\t\t}\n\n\t\t&_vat {\n\t\t\tbackground-color: var(--color-light-red);\n\t\t}\n\n\t\t&_discount {\n\t\t\tbackground-color: var(--color-primary-7);\n\t\t}\n\n\t\t&_due {\n\t\t\tbackground-color: var(--color-error);\n\t\t\tcolor: var(--color-white);\n\t\t}\n\n\t\t&_owe {\n\t\t\tbackground-color: var(--color-error);\n\t\t\tcolor: var(--color-white);\n\t\t}\n\t}\n}\n\n.main {\n\tdisplay: grid;\n\tgrid-template-columns: 1.85fr 1fr;\n\talign-items: center;\n\twidth: 100%;\n\tbox-sizing: border-box;\n\n\t@media only screen and (max-width: $bp-600) {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t&_nav {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tflex-wrap: wrap;\n\t\tmargin-top: 2rem;\n\t\tpadding: 0 2rem;\n\t\t// border-top: solid 1px var(--color-primary);\n\t\tbackground-color: var(--color-white);\n\t\tborder-bottom: solid 1px var(--color-dark);\n\t\tborder-radius: 1rem 1rem 0 0;\n\n\t\t& > :not(:last-child) {\n\t\t\tmargin-right: 1rem;\n\t\t}\n\n\t\t&_group {\n\t\t\tposition: relative;\n\t\t}\n\n\t\t&_more {\n\t\t\tposition: absolute;\n\t\t\tright: 0;\n\t\t\ttop: 75%;\n\t\t\tbackground-color: var(--color-white);\n\t\t\tpadding: 1.5rem;\n\t\t\tborder-radius: 1rem;\n\t\t\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\t\t\tz-index: 5;\n\n\t\t\t& > :not(last-child) {\n\t\t\t\tmargin-bottom: 1rem;\n\t\t\t}\n\t\t}\n\n\t\t&_item {\n\t\t\tcursor: pointer;\n\t\t\tpadding: 1rem 0;\n\t\t\tbox-sizing: border-box;\n\t\t\tfont-size: var(--default-font-small);\n\n\t\t\t// @media only screen and (max-width: $bp-600) {\n\t\t\t// \twidth: 47%;\n\t\t\t// }\n\n\t\t\t&_active {\n\t\t\t\tcursor: pointer;\n\t\t\t\tpadding: 1rem 0;\n\t\t\t\tbox-sizing: border-box;\n\t\t\t\tfont-size: var(--default-font-small);\n\t\t\t\tfont-weight: 700;\n\t\t\t\tcolor: var(--color-primary);\n\t\t\t\tborder-bottom: solid 2px var(--color-primary);\n\t\t\t}\n\n\t\t\t&:hover,\n\t\t\t&:focus,\n\t\t\t&:focus-visible,\n\t\t\t&:focus-within {\n\t\t\t\tfont-weight: 700;\n\t\t\t\tcolor: var(--color-primary);\n\t\t\t\tborder-bottom: solid 2px var(--color-primary);\n\t\t\t}\n\t\t}\n\t}\n\n\t// & > :nth-child(3) {\n\t// \tgrid-column: 1/3;\n\t// \tgrid-row: 2/3;\n\t// }\n}\n\n.success {\n\theight: 27rem;\n\tmargin-bottom: 3rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"upper": `Commission_upper__2lwWJ`,
	"upper__ql": `Commission_upper__ql__e7v7P`,
	"upper__ql__content": `Commission_upper__ql__content__jVV6P`,
	"upper__metrics": `Commission_upper__metrics__hx6QF`,
	"upper__metrics_paid": `Commission_upper__metrics_paid__LLhRj`,
	"upper__metrics_unpaid": `Commission_upper__metrics_unpaid__UvqwG`,
	"upper__metrics_partPaid": `Commission_upper__metrics_partPaid__Wgehm`,
	"upper__metrics_vat": `Commission_upper__metrics_vat__-B+vh`,
	"upper__metrics_discount": `Commission_upper__metrics_discount__pdV6r`,
	"upper__metrics_due": `Commission_upper__metrics_due__UWmPT`,
	"upper__metrics_owe": `Commission_upper__metrics_owe__7JFbq`,
	"main": `Commission_main__wxD3E`,
	"main_nav": `Commission_main_nav__wXIYL`,
	"main_nav_group": `Commission_main_nav_group__CASzZ`,
	"main_nav_more": `Commission_main_nav_more__HmOMG`,
	"main_nav_item": `Commission_main_nav_item__2fPtK`,
	"main_nav_item_active": `Commission_main_nav_item_active__XJfwq`,
	"success": `Commission_success__BdwBn`
};
export default ___CSS_LOADER_EXPORT___;
